"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TYPE_OPTIONS = {
  BUTTON_LOADER: "buttonLoader",
  SEARCH_LOADER: "searchLoader",
  BOX_LOADER: "boxLoader",
  PAGE_LOADER: "pageLoader",
  INLINE_LOADER: "inlineLoader"
};
var _default = TYPE_OPTIONS;
exports.default = _default;